// extracted by mini-css-extract-plugin
export default {"root":"SkeletonText__root___t9ecf"};